export * from './CyanMaterial';
export { default as LineClearEffect } from './effects/IceLineClearEffect';
export { default as TetrisFinisher } from './effects/IceTetrisFinisher';
export { default as HardDropTrail } from './effects/IceHardDropTrail';
export { default as BlockPlaceEffect } from './effects/IceBlockPlaceEffect';
export { default as Block3D } from './IceBlock3D';
export { default as BoardGrid3D } from './IceBoardGrid3D';

// Re-export theme config
export { THEME_CONFIG } from './CyanMaterial';

// Default export with all theme components
const CyanTheme = {
  name: 'Cyan',
  getBlockColor: require('./CyanMaterial').getBlockColor,
  getEmissiveColor: require('./CyanMaterial').getEmissiveColor,
  COLORS: require('./CyanMaterial').ICE_COLORS,
  TETROMINO_COLORS: require('./CyanMaterial').ICE_TETROMINO_COLORS,
  config: require('./CyanMaterial').THEME_CONFIG,
  Block3D: require('./IceBlock3D').default,
  BoardGrid3D: require('./IceBoardGrid3D').default,
  effects: {
    LineClearEffect: require('./effects/IceLineClearEffect').default,
    TetrisFinisher: require('./effects/IceTetrisFinisher').default,
    HardDropTrail: require('./effects/IceHardDropTrail').default,
    BlockPlaceEffect: require('./effects/IceBlockPlaceEffect').default,
  },
};

export default CyanTheme;
